import {
    UPDATE_POINT_OF_INTEREST,
    UPDATE_POINT_OF_INTEREST_FAILURE,

    UPDATE_POINT_OF_INTEREST_LOCALISATION,
    UPDATE_POINT_OF_INTEREST_LOCALISATION_FAILURE,
    UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const updatePointOfInterest = (payload) => {
    return {
        type: UPDATE_POINT_OF_INTEREST,
        payload: payload,
    };
};

export const updatePointOfInterestFailure = (error) => {
    return {
        type: UPDATE_POINT_OF_INTEREST_FAILURE,
        error: error,
    };
};

export const updatePointOfInterestLocalisation = (payload, response) => {
    return {
        type: UPDATE_POINT_OF_INTEREST_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const updatePointOfInterestLocalisationFailure = (error) => {
    return {
        type: UPDATE_POINT_OF_INTEREST_LOCALISATION_FAILURE,
        error: error,
    };
};

export const updatePointOfInterestLocalisationSuccess = (payload, response) => {
    return {
        type: UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/updatePointsOfInterest.js